import { API_INSTANCE } from 'src/features/utils';

export const fetchTrackingLinksApi = async (eventId: string) => {
  const response = await API_INSTANCE.get(`/api/v1/dashboard/tracking-links/events/${eventId}`);
  return response.data;
};

export const createTrackingLinkApi = async (data: {
  eventId: string;
  name: string;
  url: string;
}) => {
  const response = await API_INSTANCE.post(
    `/api/v1/dashboard/tracking-links/events/${data.eventId}`,
    { name: data.name, url: data.url },
  );
  return response.data;
};

export const deleteTrackingLinkApi = async (data: { eventId: string; linkId: string }) => {
  const response = await API_INSTANCE.delete(
    `/api/v1/dashboard/tracking-links/${data.linkId}/events/${data.eventId}`,
  );
  return response.data;
};
